import "./Homes.jsx"
import "./about.css"

const About =() => {
    return(
        <>
        <div className="about">
            <img src="founder.png" alt="founder img" />
            <h5>"The rich flavors are even more memorable knowing that it's all sustainably sourced"</h5>
            <h5>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ab, velit!</h5>
            <p> Amber Detroit</p>
        </div>
        <div>
            <img src="img.png" alt="" style={{width:'100%'}} />
        </div>

        </>

    )
}
export default About;